import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

import OffersCoupon from 'organisms/CartPage/Presentation/ReusableComponents/OffersCoupon';

import { getTernaryValue, getSumOfQuantityWithoutHopeBag } from 'common/utilities/utils';

export const getTitlePanel = title => {
  return <h5 className='price-summary-item-title'>{title}</h5>;
};

export const getCartItemPanel = (foodLines, addHope, carryBag) => {
  const quantity = getSumOfQuantityWithoutHopeBag(foodLines, addHope, carryBag);
  return (
    <h2 className='checkout-summary-item-count'>
      {quantity}{' '}
      {getTernaryValue(
        quantity === 1,
        translateWithI18Next(TRANSLATE_MAPPING_KEY?.CART_ITEM),
        translateWithI18Next(TRANSLATE_MAPPING_KEY?.CART_ITEMS),
      )}
    </h2>
  );
};

export const getOffersCouponPanel = (userParams, bucketId) => {
  return (
    userParams.loggedIn && (
      <div className='checkout-summary-coupons'>
        <OffersCoupon bucketId={bucketId} />
      </div>
    )
  );
};
